import React, {useState} from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import Login from './views/login/Login'
import ForgotPassword from './views/forgotpassword/ForgotPassword'

import Companies from './views/companies/Companies'
import Users from './views/users/Users'
import Behaviours from './views/behaviours/Behaviours'
import Situations from './views/situations/Situations'
import UserAssessments from './views/assessments/Assessments';
import ReportEditor from './views/reporteditor/ReportEditor'
import TestActivity from './testactivity/TestActivity';
import Training from './views/training/Training';
import ChangePassword from './views/changepassword/ChangePassword';

import './App.css';
import BehavioralClusters from './views/behavioralclusters/BehavioralClusters';
import { TestCompletion } from './testactivity/TestCompletion';
import Unauthorized from './testactivity/Unauthorized';

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));

  if(!token){
    return (
      <div className='App'>
        <Router>
            <Routes>
                <Route path="/" element={<Login setToken={setToken} />}/>
                <Route path="/forgotpassword" element={<ForgotPassword />}/>
                <Route path="/assessment" element={<TestActivity />}/>
                <Route path="/testcompletion" element={<TestCompletion />}/>
                <Route path="/unauthorized" element={<Unauthorized />}/>
            </Routes>
          </Router>
      </div>
    );
  }
  else{
    return (
      <div className='App'>
        <Router>
            <Routes>
                <Route path="/" element={<UserAssessments />} />
                <Route path="/companies">
                  <Route index element={<Companies />}/>
                </Route>
                <Route path="/users">
                  <Route index element={<Users />}/>
                </Route>
                <Route path="/training">
                  <Route index element={<Training />}/>
                </Route>
                <Route path="/changepassword">
                  <Route index element={<ChangePassword />}/>
                </Route>
                <Route path="/userassessments">
                  <Route index element={<UserAssessments />}/>
                </Route>
                <Route path="/behavioralclusters" element={<BehavioralClusters />}/>
                <Route path="/behaviors">
                  <Route index element={<Behaviours />}/>
                </Route>
                <Route path="/situations">
                  <Route index element={<Situations />}/>
                </Route>
                <Route exact path="/editor" element={<ReportEditor type="report"  />}/>
                <Route path="/assessment" element={<TestActivity />}/>
                <Route path="/testcompletion" element={<TestCompletion />}/>
                <Route path="/unauthorized" element={<Unauthorized />}/>
            </Routes>
          </Router>
      </div>
    );
  }
}

export default App;
